import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                福利视频网址大全
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚全网最新福利视频网址，每日更新高清资源入口，告别失效链接烦恼。安全稳定，极速播放，无需注册即可使用。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/zongyi" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">综艺娱乐</Link>
              <Link to="/category/dianying" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">电影资源</Link>
              <Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">电视剧</Link>
              <Link to="/category/dongman" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">动漫动画</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/jilupian" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">纪录片</Link>
              <Link to="/category/tiyu" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">体育赛事</Link>
              <Link to="/category/yinyue" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">音乐MV</Link>
              <Link to="/category/xuexi" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">学习教育</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">联系方式</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2020-2026 福利视频网址大全 版权所有
          </p>
          <p className="text-sm text-background-500">
            本站为视频资源导航平台，收录内容均来自互联网公开资源
          </p>
        </div>
      </div>
    </footer>
  );
}